/** Numeric CRM value wins; only unambiguous legacy labels are interpreted. */
export function packageDurationMinutes(plan?: {
  durationMinutes?: number;
  durationLabel?: string;
}) {
  if (plan?.durationMinutes) return plan.durationMinutes;
  const match =
    /^(?:up to\s+)?(\d+(?:[.,]\d+)?)\s*(hours?|hrs?|h|minutes?|mins?)(?:\s+(?:of\s+)?(?:coverage|shoot|session))?$/i.exec(
      plan?.durationLabel?.trim() ?? '',
    );
  if (!match) return 60;
  const minutes = Math.round(
    Number(match[1]!.replace(',', '.')) * (/^h/i.test(match[2]!) ? 60 : 1),
  );
  return minutes > 0 && minutes <= 10080 ? minutes : 60;
}
